import type { FixedLineItem, RevisionedLineItem } from '@weft/types';
import { isNotEmptyArray } from '@weft/utils';
import React from 'react';
import { useInvoiceCurrency } from '../../../../hooks/use-invoice-currency';
import { getProductTitle } from '../../../../services/product/product-title';
import { InvoiceSectionHeader } from './InvoiceSectionHeader';

type InvoiceFixedFeeChargesProps = {
  fixedLineItems: FixedLineItem[];
  revisionedLinedItems: RevisionedLineItem[];
};

export const InvoiceFixedFeeCharges: React.FC<InvoiceFixedFeeChargesProps> = ({
  fixedLineItems,
  revisionedLinedItems,
}) => {
  const currency = useInvoiceCurrency(fixedLineItems);

  return (
    <div className="mt-10">
      <div className="text-title mb-4 text-base">Fixed Fees</div>
      <div className="space-y-5">
        {fixedLineItems.map((lineItem) => {
          return (
            <div
              className="rounded-2lg border-line border p-5"
              key={crypto.randomUUID()}
            >
              <InvoiceSectionHeader
                name={getProductTitle(lineItem.lineItemProduct)}
                description={lineItem.lineItemProduct.variants[0].description}
                price={lineItem.price}
                currency={currency}
              />
            </div>
          );
        })}

        {isNotEmptyArray(revisionedLinedItems) && revisionedLinedItems.map((lineItem) => (
          <div
            className="rounded-2lg border-line border p-5"
            key={lineItem.id}
          >
            <InvoiceSectionHeader
              name={lineItem.name}
              price={lineItem.price}
              currency={currency}
            />
          </div>
        ))}
      </div>
    </div>
  );
};